/* @flow strict */

/* eslint-disable max-len */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import useOutsideClick from './../../utils/useOutsideClick';
import moment from 'moment';
import _ from 'lodash';
import lockTransferTicket from './../../utils/lockTransferTicket';
import { convertToLocalTime } from '/client/src/utils/jstz';

import './styles.scss';
import { PUT } from '../../api';
import CssPinner from '../csspinner';

type PropsType = {
  type?: string,
  id?: string,
  children?: React.Node,
  className?: string,
  startDate?: string,
  forWidget?: boolean,
  forWidgetCallback?: () => void,
  image_url?: string,
  image_crop_info?: {
    x1: number,
    x2: number,
    y1: number,
    y2: number
  },
  extraContent?: React.Node | null,
  extraImg?: React.Node | null,
  extraBack?: React.Node | null,
  viewTicket?: boolean,
  setEventList?: () => void,
  eventList?: [],
  disableAction?: boolean,
  toggleRegistrationDialogData?: () => void,
  need_registration_confirm?: boolean
};

const EventCardLine = (props: PropsType): React.Element<typeof React.Fragment> => {
  const [isShowDrop, handleShowDrop] = React.useState(false);
  const ref = React.useRef();
  const EventCardRef = React.useRef();
  const x1 = _.get(props.image_crop_info, 'x1', 0);
  const x2 = _.get(props.image_crop_info, 'x2', 0);
  const y1 = _.get(props.image_crop_info, 'y1', 0);
  const y2 = _.get(props.image_crop_info, 'y2', 0);

  const { viewTicket, extraContent, extraImg, extraBack, type, disableAction, startDate, time_zone_id } = props;

  useOutsideClick(ref, () => {
    handleShowDrop(false);
  });

  let fixStyleClass = '';

  let isNoLockFn = false;

  const isShowRegistration = !props.need_registration_confirm; // TODO

  if (isShowDrop && props.forWidget) {
    const lockedId = process.env.NODE_ENV === 'development' ? '480713639197040640' : '131567398342909952';

    isNoLockFn = lockTransferTicket(props, lockedId, 'merchant_id');
    fixStyleClass = !isNoLockFn ? 'oneRow' : 'twoRow';
  }


  if (type === 'new-event') {
    return (
      <div className="_row">
        <div className="EventCardLineAdd">
          <Link to="/events/new" className="event-panel event-add">
            <span className="icon-add">
              <i className="icon icon-plus-circle" style={{ fontSize: '48px' }} />
            </span>
            <span>new event</span>
          </Link>
        </div>
      </div>
    );
  }

  const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=480`;
  const ArchiveControlHandler = async () => {
    try {
      CssPinner(EventCardRef.current, true);
      await PUT(`/api/v1/1/events/${props.id}/${props.status === 'Archive' ? 'unarchive' : 'archive'}`);

      props.setEventList([
        ..._.filter(props.eventList, (ev :{}): {} => _.toString(ev.id) !== _.toString(props.id))
      ]);

      CssPinner(EventCardRef.current, false);
    } catch (e) {
      CssPinner(EventCardRef.current, false);
    }
  };

  return (
    <div className="_row" ref={EventCardRef}>
      {/* eslint-disable-next-line*/}
      <div className={`EventCardLine ${props.className ? `EventCardLine-${props.className}` : ''} ${viewTicket ? 'EventCardLine__view' : ''}`}>
        <div className="EventCardLine-col EventCardLine-col--img">
          <div className="EventCardLine-dateImg">
            <div className='EventCardLine-dateImg-month'>{convertToLocalTime(startDate, time_zone_id, 'MMM')}</div>
            <div className='EventCardLine-dateImg-date'>{convertToLocalTime(startDate, time_zone_id, 'DD')}</div>
          </div>
          <div className="EventCardLine-img" style={{ display: 'none' }}>
            <div
              className="EventCardLine-img-picture"
              style={{
                backgroundImage: `url("${props.image_url}?${imageUrlParams}")`
                // backgroundImage: `url("${props.image_url}?maxwidth=3200&maxheight=3200&crop=(${x1}%2C${y1}%2C${x2}%2C${y2})&width=480)")`
              }}
            />
            {extraImg ? extraImg : null}
          </div>
        </div>

        {props.children}

        {extraContent ? extraContent : null}

        {!disableAction &&
        <div className="EventCardLine-col EventCardLine-col--action">
          <div
            className="EventCardLine-actions"
          >
            {!!extraBack && extraBack}
            <button className="EventCardLine-menuBtn" onClick={(): any => handleShowDrop(!isShowDrop)} ref={ref} >
              <i className="glyphicon glyphicon-option-vertical"/>
            </button>
          </div>

          {isShowDrop ?
            <>
              <ul
                className={`dropdown-menu EventCardLine-dropdown-menu show ${fixStyleClass}`}
              >
                {!props.forWidget ?
                  <>
                    <li className="dropdown-header">Configure</li>
                    <li>
                      <Link to={`/events/${props.id}/edit`}>Edit</Link>
                    </li>
                    <li>
                      <Link to={`/events/${props.id}/manage`}>Manage</Link>
                    </li>
                    <li>
                      <Link to={`/events/${props.id}/customers`}>Guests</Link>
                    </li>
                    <li>
                      <Link to={`/events/${props.id}/stats`}>Stats</Link>
                    </li>
                    <li role="separator" className="divider" />
                    <li className="dropdown-header">Actions</li>
                    <li>
                      <Link to={`/events/${props.id}/clone`}>Clone</Link>
                    </li>
                    <li
                      onClick={(): void => ArchiveControlHandler()}
                    >
                      {props.status !== 'Archive' ?
                        'Archive' :
                        'Unarchive'
                      }
                    </li>
                  </> :
                  <>
                    <li className="dropdown-header__mobile" >
                      <button onClick={(): any => handleShowDrop(false)}>Close</button>
                    </li>
                    <li>
                      <a
                        href='#'
                        data-link="ticket-view"
                        className="EventCardLine-ticketView"
                        onClick={(e: any) => {
                          props.forWidgetCallback(e, props.id);
                        }}
                      >Download Ticket</a>
                    </li>
                    {isNoLockFn &&
                      <li>
                        <a
                          href='#'
                          data-link="ticket-transfer"
                          onClick={(e: any) => {
                            props.forWidgetCallback(e, props.id);
                          }}
                        >Transfer Ticket</a>
                      </li>
                    }
                    {isShowRegistration &&
                      <li>
                        <a
                          href="#"
                          data-link="view-registration"
                          onClick={(e: any) => {
                            props.forWidgetCallback(e, props);
                            props.toggleRegistrationDialogData(props);
                          }}
                        >
                          View registration
                        </a>
                      </li>
                    }
                    {/* <li>
                      <a
                        href='#'
                        data-link="ticket-email"
                        onClick={(e: any) => {
                          props.forWidgetCallback(e, props.id);
                        }}
                      >Email Reciept</a>
                    </li> */}
                  </>
                }
              </ul>
            </> :
            null
          }
        </div>
        }
      </div>

      {isShowDrop ? <div className="EventCardLine-dropdown-menu-backdrop" /> : null}
    </div>
  );
};

export default withRouter(EventCardLine);
